module.exports = __webpack_public_path__ + "img/pay.6dcd3262.jpg";